var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceMyOrdo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 18.75,
    viewBox: "0 0 25 18.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.062,7.749V6.844h.781a.781.781,0,0,0,.781-.781V5.281a.781.781,0,0,0-.781-.781H10.156a.781.781,0,0,0-.781.781v.781a.781.781,0,0,0,.781.781h.781v.905A10.931,10.931,0,0,0,1.563,18.562H23.438A10.931,10.931,0,0,0,14.062,7.749ZM24.219,20.125H.781A.781.781,0,0,0,0,20.906v1.563a.781.781,0,0,0,.781.781H24.219A.781.781,0,0,0,25,22.469V20.906A.781.781,0,0,0,24.219,20.125Z",
    transform: "translate(0 -4.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceMyOrdo);
export default __webpack_public_path__ + "static/media/place-my-ordo.8c6554db64b73b6f1200e8f3a2dfe4a2.svg";
export { ForwardRef as ReactComponent };